module.exports = __webpack_public_path__ + "static/media/buyNowPopUpFreeCard.98ddafcc.svg";